import React, { useState, useEffect } from "react";
import "../../../Styles/Modal.css";
import "../../../Styles/reModal.css";
import { ImCancelCircle } from "react-icons/im";
import ProductQuantity from "./ProductQuantity";
import axios from "axios";

type Product = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: { selling: string };
  quantity: string;
  _id: string;
};

type Bank = {
  bankName: string;
  _id: string;
  products: Product[];
};

const ProductModal = ({
  handleProModal,
  handleProSelect,
  selPro,
  sign,
  handleChange,
  checkingQuan,
  setOpPro,
  customerID,
}: any) => {
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [aggregateData, setAggregateData] = useState({
    totalQuantity: 0,
    averagePrice: 0,
  });
  const [banks, setBanks] = useState<Bank[]>([]);
  const [selectedBankId, setSelectedBankId] = useState<string>("");
  const [availableQuantity, setAvailableQuantity] = useState<number>(0);
  const [opProQuan, setOpProQuan] = useState<boolean>(false);

  const handleProductClick = (product: Product) => {
    setSelectedProduct(product);
    setSelectedBankId("");
  };

  useEffect(() => {
    if (selectedProduct) {
      calculateAggregateData(selectedProduct);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (customerID) {
      fetchBanks(customerID);
    }
  }, [customerID]);

  const fetchBanks = async (cusID: string) => {
    const token = window.localStorage.getItem('token');

    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    };

    try {
      const response = await axios.get(`https://apibiz.oneflaretech.com/api/customer`, {
        headers: headers,
      });
      const bankData = response.data.data;
      const customer = bankData.find((customer: any) => customer._id === cusID);
      if (customer) {
        const customerBanks = customer.customerAccount.map((account: any) => ({
          bankName: account.bank.bankName,
          _id: account.bank._id,
          products: account.product
        }));
        setBanks(customerBanks);
      }
    } catch (error) {
      console.error('Error fetching banks:', error);
    }
  };

  const calculateAggregateData = (product: Product) => {
    const productData = checkingQuan.find((cus: any) =>
      cus.product.some((pre: any) => pre._id === product._id)
    )?.product;

    if (productData) {
      const totalQuantity = productData.reduce(
        (sum: number, item: Product) => sum + parseFloat(item.quantity || "0"),
        0
      );
      const totalPrice = productData.reduce(
        (sum: number, item: Product) =>
          sum + parseFloat(item.price?.selling || "0"),
        0
      );
      const averagePrice = productData.length
        ? totalPrice / productData.length
        : 0;

      setAggregateData({
        totalQuantity,
        averagePrice,
      });
    }
  };

  const handleBankChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedBankId(event.target.value);

    const selectedBank = banks.find(bank => bank._id === event.target.value);
    if (selectedBank && selectedProduct) {
      const productInBank = selectedBank.products.find((prod: Product) => prod._id === selectedProduct._id);
      if (productInBank) {
        setAvailableQuantity(parseFloat(productInBank.quantity));
      } else {
        setAvailableQuantity(0);
      }
    }
  };

  const handleSelect = () => {
    setOpPro(true);
    setOpProQuan(true); // Open the ProductQuantity modal
  };

  const uniqueProducts: Product[] = Array.from(
    checkingQuan
      .flatMap((cus: any) => (cus.product as Product[] || []))
      .reduce((map: Map<string, Product>, product: Product) => {
        if (!map.has(product._id)) {
          map.set(product._id, product);
        }
        return map;
      }, new Map<string, Product>())
      .values()
  );

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Product</h4>
          <ImCancelCircle className="catCancel" onClick={handleProModal} />
        </div>
        <div className="line"></div>

        <div className="cusmm">
          {uniqueProducts.map((pre: Product) => {
            const isSelected = pre._id === selectedProduct?._id;
            const customerClassName = isSelected ? "payT payDark" : "payT";
            return (
              <div
                key={pre._id}
                className={customerClassName}
                onClick={() => handleProductClick(pre)}
              >
                <p>{pre.name}</p>
              </div>
            );
          })}
        </div>

        {selectedProduct && (
          <>
            <div className="modalContent">
              <select value={selectedBankId} onChange={handleBankChange}>
                <option value="" disabled>
                  Select a bank
                </option>
                {banks.map((bank) => (
                  <option key={bank._id} value={bank._id}>
                    {bank.bankName}
                  </option>
                ))}
              </select>
            </div>
            <div className="modalContent">
              <p>Available Quantity: {availableQuantity}</p>
            </div>
          </>
        )}

        <div className="catModalBtn">
          <button
            className={`${selectedProduct && selectedBankId ? "catBtn1" : "opBtn"}`}
            onClick={handleSelect}
            disabled={!selectedProduct || !selectedBankId}
          >
            Next
          </button>
        </div>
      </div>
      {opProQuan && (
        <ProductQuantity
          selectProduct={selectedProduct}
          handleProQuanModal={() => setOpProQuan(false)}
          sign={sign}
          handleChange={handleChange}
          setOpPro={setOpPro}
          handleProSelect={handleProSelect}
        />
      )}
    </div>
  );
};

export default ProductModal;
